import { gql } from '@apollo/client'

export const GET_ELIGIBLE_MANAGERS = gql`
  query GetEligibleManagers($input: CompanyUsersInput!) {
    companyUsers(input: $input) {
      results {
        id
        name
        zoneAsManager {
          name
          zonePath
        }
        zone {
          name
          zonePath
        }
      }
    }
  }
`
